import { connect } from 'react-redux';

import {
  currentAppDefinitionEntity,
  currentAppEntity,
} from 'app/developer-v3/selectors';
import {
  selectAppId,
  selectDefinitionOverride,
  selectIsAppVersionSaving,
  selectVersionNumber,
} from 'app/developer-v3/store/selectors';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import hocify from 'app/common/components/hocify';
import { notify } from 'app/developer-v3/store/shared/actions';
import * as CliApp from 'app/entities/CliApp';
import * as CliAppDefinition from 'app/entities/CliAppDefinition';
import * as DeveloperActions from 'app/developer-v3/Actions';

import Wrapper from './Wrapper';

import type { Flags } from 'app/developer-v3/platformSchema/flags';

const mapStateToProps = state => {
  const integrationId = selectAppId(state);

  const appEntity = currentAppEntity(state);
  const isPrivate = CliApp.selectors.isPrivate(appEntity);
  const appDefinitionEntity = currentAppDefinitionEntity(state);
  const definitionOverride = selectDefinitionOverride(state);

  const isLoading =
    CliApp.selectors.all.isLoadingById(integrationId, state) ||
    CliAppDefinition.selectors.all.isLoadingById(integrationId, state);

  const isGUIIntegration =
    !isLoading &&
    CliAppDefinition.selectors.isGUIIntegration(appDefinitionEntity);

  return {
    flags: definitionOverride?.flags ?? {
      skipHttpPatch: false,
      skipThrowForStatus: false,
    },
    integrationId,
    integrationVersion: selectVersionNumber(state),
    isGUIIntegration,
    isIntegrationPrivate: isPrivate,
    isLoading,
    isSaving: selectIsAppVersionSaving(state),
  };
};

const mapDispatchToProps = (dispatch, props) => ({
  onLoad() {
    const { id, version } = props.params;
    dispatch(DeveloperActions.loadAppAndVersion(id, version));
  },
  saveFlags: async (flags: Flags) =>
    dispatch(async (_dispatch, getState) => {
      const state = getState();
      const definitionOverride = selectDefinitionOverride(state);
      const definitionOverrideNext = {
        ...definitionOverride,
        flags,
      };

      const isSuccess = await dispatch(
        DeveloperActions.updateAppDefinition(definitionOverrideNext)
      );

      if (isSuccess) {
        dispatch(notify.success('Updated advanced settings.'));
      }
    }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(hocify(LoadingBlockOrComponent)(Wrapper));
